import axios from "axios";
import baseApiHelper from "app/redux/baseApiHelper";
import { getBaseUrl, getBaseUrlForEsync } from "./utils";


export const axiosBaseQuery = () =>
  async ({ url, method, data, params, ...rest } = {}) => { 
    try {

      // // CC-71241: Maintenance Mode
      // if (window.__APP_MAINTENANCE__) {
      //   return { error: { status: 503, data: "maintenance" } };
      // }
      
      if (url) {

        let newBaseUrl = rest?.python ? getBaseUrlForEsync() : getBaseUrl();
        const result = await axios({
          url: newBaseUrl + url,
          method,
          data,
          params,
        });
        if (
          (result?.data &&
            !data?.skip_auto_accept_frontend &&
            result?.data?.response &&
            result?.data?.response?.meta &&
            result?.data?.response?.meta?.auto_accept_response) ||
          url?.indexOf("notes/accept.json") > -1
        ) {
          baseApiHelper().noteAutoAcceptHook(url, result, data, true);
        }
        if (
          result?.data &&
          result?.data?.response &&
          result?.data?.response?.code != 0 && 
          !params?.skip_error_msg
        ) {
          baseApiHelper().responseMSGCheck(result?.data?.response);
        }
        return { data: result.data };
      } else {
        return null;
      }
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
